import React from "react";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";

const ApplicationCard = ({ children, companyCredit, isDisabled, setSelectedApplication }) => {
  const { t } = useTranslation();

  return (
    <Card
      className={"p-4 default-card position-relative hover-shadow"}
      style={{ height: "300px", backgroundColor: isDisabled ? "#f7f7f7" : null }}
      onClick={(e) => {
        setSelectedApplication(companyCredit);
      }}
    >
      {children}
    </Card>
  );
};
export default ApplicationCard;
